import * as React from "react"
import { CollectionSearch } from "./collection-search"
import type { CollectionSearchProps } from "./types"

export interface UserSearchProps
  extends Omit<CollectionSearchProps, "collection" | "displayMode"> {
  /** Additional filter beyond default user filtering */
  filter?: Record<string, any>
  /** Show only active users (default true) */
  activeOnly?: boolean
}

/**
 * UserSearch - Pre-configured CollectionSearch for users.
 *
 * Features enhanced user display showing name, departments, and availability status.
 *
 * @example
 * <UserSearch
 *   value={userId}
 *   onChange={(option) => setUserId(option?.value || null)}
 *   placeholder="Assign to user..."
 * />
 *
 * @example
 * // With division filter
 * <UserSearch
 *   value={userId}
 *   onChange={(option) => setUserId(option?.value || null)}
 *   filter={{ divisions: { $in: [divisionId] } }}
 *   label="Assign to"
 * />
 */
export function UserSearch({
  placeholder = "Search users...",
  filter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  activeOnly = true,
  ...props
}: UserSearchProps) {
  // Merge with deleted: false filter
  const mergedFilter = { ...filter, deleted: false }

  return (
    <CollectionSearch
      {...props}
      collection="users"
      displayMode="users"
      filter={mergedFilter}
      placeholder={placeholder}
    />
  )
}
